// src/pages/AdminProducts.jsx
import React, { useState, useEffect } from "react";
import api from "../api/api";
import Spinner from "../components/common/Spinner";
import { toast } from "react-toastify";
import { FiTrash2, FiPlus, FiShoppingBag, FiLink, FiImage, FiTag } from "react-icons/fi";

export default function AdminProducts() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  // Estado do formulário
  const [formData, setFormData] = useState({
    name: "",
    price: "",
    old_price: "",
    image_url: "",
    link_purchase: ""
  });

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const res = await api.get("/products");
      setProducts(res.data.products || []);
    } catch (err) {
      console.error(err);
      toast.error("Erro ao carregar produtos");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.post("/admin/products", formData);
      toast.success("Produto adicionado com sucesso!");
      setFormData({ name: "", price: "", old_price: "", image_url: "", link_purchase: "" });
      fetchProducts(); // Recarrega a lista
    } catch (err) {
      console.error(err);
      toast.error("Erro ao salvar produto. Verifique o console.");
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Tem certeza que deseja excluir este produto?")) return;
    try {
      await api.delete(`/admin/products/${id}`);
      toast.success("Produto removido!");
      setProducts(products.filter(p => p.id !== id));
    } catch (err) {
      toast.error("Erro ao excluir");
    }
  };

  if (loading) return <div className="p-20 flex justify-center"><Spinner /></div>;

  return (
    <div className="p-6 max-w-6xl mx-auto animate-fadeIn">
      <div className="flex items-center gap-3 mb-8">
        <div className="p-3 bg-emerald-600 rounded-xl text-white shadow-lg">
          <FiShoppingBag size={24} />
        </div>
        <div>
          <h1 className="text-2xl font-black uppercase tracking-tight text-gray-800">Gerenciar Vitrine</h1>
          <p className="text-gray-500 text-sm">Adicione produtos físicos ou links de afiliados para a Home</p>
        </div>
      </div>

      <div className="grid lg:grid-cols-3 gap-8">
        
        {/* FORMULÁRIO DE CADASTRO */}
        <div className="lg:col-span-1">
          <form onSubmit={handleSubmit} className="bg-white p-6 rounded-3xl shadow-sm border border-gray-100 sticky top-6">
            <h2 className="text-lg font-bold mb-6 flex items-center gap-2">
              <FiPlus className="text-emerald-500" /> Novo Produto
            </h2>

            <div className="space-y-4">
              <div>
                <label className="text-xs font-black uppercase text-gray-400 mb-1 block">Nome do Produto</label>
                <div className="relative">
                  <FiTag className="absolute left-3 top-3 text-gray-400" />
                  <input
                    required
                    className="w-full pl-10 pr-4 py-2 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-emerald-500 outline-none transition-all"
                    placeholder="Ex: Apostila de Anatomia"
                    value={formData.name}
                    onChange={e => setFormData({...formData, name: e.target.value})}
                  />
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="text-xs font-black uppercase text-gray-400 mb-1 block">Preço Atual</label>
                  <input
                    required
                    type="number"
                    step="0.01"
                    className="w-full px-4 py-2 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-emerald-500 outline-none"
                    placeholder="0.00"
                    value={formData.price}
                    onChange={e => setFormData({...formData, price: e.target.value})}
                  />
                </div>
                <div>
                  <label className="text-xs font-black uppercase text-gray-400 mb-1 block">Preço Antigo</label>
                  <input
                    type="number"
                    step="0.01"
                    className="w-full px-4 py-2 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-emerald-500 outline-none"
                    placeholder="Opcional"
                    value={formData.old_price}
                    onChange={e => setFormData({...formData, old_price: e.target.value})}
                  />
                </div>
              </div>

              <div>
                <label className="text-xs font-black uppercase text-gray-400 mb-1 block">URL da Imagem</label>
                <div className="relative">
                  <FiImage className="absolute left-3 top-3 text-gray-400" />
                  <input
                    className="w-full pl-10 pr-4 py-2 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-emerald-500 outline-none"
                    placeholder="https://link-da-imagem.jpg"
                    value={formData.image_url}
                    onChange={e => setFormData({...formData, image_url: e.target.value})}
                  />
                </div>
              </div>

              <div>
                <label className="text-xs font-black uppercase text-gray-400 mb-1 block">Link de Compra</label>
                <div className="relative">
                  <FiLink className="absolute left-3 top-3 text-gray-400" />
                  <input
                    required
                    className="w-full pl-10 pr-4 py-2 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-emerald-500 outline-none"
                    placeholder="Link do Checkout ou Hotmart"
                    value={formData.link_purchase}
                    onChange={e => setFormData({...formData, link_purchase: e.target.value})}
                  />
                </div>
              </div>

              <button
                type="submit"
                disabled={saving}
                className="w-full py-4 bg-gray-900 text-white rounded-2xl font-bold uppercase tracking-widest hover:bg-emerald-600 transition-all disabled:opacity-50 shadow-lg active:scale-95"
              >
                {saving ? "Salvando..." : "Cadastrar Produto"}
              </button>
            </div>
          </form>
        </div>

        {/* LISTAGEM DE PRODUTOS */}
        <div className="lg:col-span-2">
          <div className="bg-white rounded-3xl border border-gray-100 overflow-hidden shadow-sm">
            <table className="w-full text-left border-collapse">
              <thead className="bg-gray-50 border-b border-gray-100">
                <tr>
                  <th className="p-4 text-xs font-black uppercase text-gray-400">Produto</th>
                  <th className="p-4 text-xs font-black uppercase text-gray-400">Preço</th>
                  <th className="p-4 text-xs font-black uppercase text-gray-400 text-center">Ações</th>
                </tr>
              </thead>
              <tbody>
                {products.length === 0 ? (
                  <tr>
                    <td colSpan="3" className="p-10 text-center text-gray-400 italic">Nenhum produto cadastrado na vitrine.</td>
                  </tr>
                ) : (
                  products.map(p => (
                    <tr key={p.id} className="border-b border-gray-50 hover:bg-gray-50 transition-colors">
                      <td className="p-4">
                        <div className="flex items-center gap-3">
                          <img src={p.image_url || "/img/placeholder.png"} className="w-12 h-12 rounded-lg object-cover bg-gray-100" alt="" />
                          <span className="font-bold text-gray-700">{p.name}</span>
                        </div>
                      </td>
                      <td className="p-4">
                        <span className="text-emerald-600 font-bold">R$ {p.price}</span>
                        {p.old_price && <span className="text-xs text-gray-300 line-through ml-2">R$ {p.old_price}</span>}
                      </td>
                      <td className="p-4 text-center">
                        <button
                          onClick={() => handleDelete(p.id)}
                          className="p-2 text-rose-500 hover:bg-rose-50 rounded-lg transition-colors"
                        >
                          <FiTrash2 size={18} />
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}